import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #INPUT-FIELD
\*------------------------------------ */
:host {
  display: block;
}

/**
 * 1) Form field that consists of a label, text input, and field note
 */
.cat-c-input-field {
  position: relative;
  --cat-input-placeholder-color: transparent;
  --cat-input-padding-vert: calc(var(--size-base-unit) * 2.125);
  --cat-input-padding-horiz: calc(var(--size-base-unit) * 2);
  height: var(--cat-input-field-height, auto);
}

/**
 * input field label
 */
.cat-c-input-field__label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  color: var(--cat-theme-color-content-default);
  transition: all 0.15s ease;
  position: relative;
  flex-basis: 100%;
  /**
   * Label in medium size
   */
  /**
   * Label in small size
   */
  /**
   * Label in readonly
   */
}
.cat-c-input-field--medium .cat-c-input-field__label {
  margin-block-end: calc(var(--size-base-unit) * 1);
  word-wrap: break-word;
  max-width: 100%;
}
.cat-c-input-field--small .cat-c-input-field__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-is-readonly .cat-c-input-field__label {
  pointer-events: none;
}
.cat-c-input-field--disabled .cat-c-input-field__label {
  color: var(--cat-theme-color-content-disabled);
}

.cat-c-input-field__label-wrapper {
  position: absolute;
  inset-inline: var(--cat-input-padding-horiz);
  inset-block-start: calc(var(--size-base-unit) * 1);
  z-index: var(--cat-z-index-100);
  display: flex;
  justify-content: space-between;
}
.cat-c-input-field--medium .cat-c-input-field__label-wrapper {
  position: static;
}
.cat-c-input-field--hidden-label .cat-c-input-field__label-wrapper {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-input-field--label {
  /**
   * Label in large size
   */
}
.cat-c-input-field--large .cat-c-input-field--label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.cat-c-input-field__label-inner-wrapper {
  display: flex;
}
.cat-c-input-field--large .cat-c-input-field__label-inner-wrapper {
  position: absolute;
  max-width: 100%;
}

/**
* Styling for Input field maxlength 
*/
slot[name=word-count] .cat-c-input-field__maxlength {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}
.cat-c-input-field--medium slot[name=word-count] .cat-c-input-field__maxlength {
  inset-inline-end: 0;
  padding-block-start: 0;
}
.cat-c-input-field--small slot[name=word-count] .cat-c-input-field__maxlength {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-c-input-field--disabled slot[name=word-count] .cat-c-input-field__maxlength {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * input field input
 */
.cat-c-input-field__input {
  appearance: none;
  width: 100%;
  border-width: var(--cat-theme-border-width);
  border-style: solid;
  border-color: var(--cat-theme-color-form-border);
  border-radius: var(--cat-theme-border-radius);
  outline: var(--cat-input-field--outline, none);
  outline-offset: var(--cat-input-field--outline-offset, 0);
  padding: calc(var(--size-base-unit) * 2);
  padding-inline-start: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  /** 
  * TODO: this line-height & font-size should be set cat-theme-typography-body 
  * currently cat-theme-typography-body is used many placed. So it got overridden directly here
  **/
  line-height: var(--cat-line-height-default, --cat-line-height-24);
  font-size: var(--cat-font-size-default, --cat-font-size-16);
  color: var(--cat-theme-color-content-default);
  background-color: var(--cat-theme-color-form-background);
  box-shadow: var(--cat-input-box-shadow);
  transition: border-color var(--cat-anim-fade-quick) var(--cat-anim-ease), background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), box-shadow var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Hover styles for default input elements
   */
  /**
   * Focus & active styles for default input elements
   */
  /**
   * When the input is clicked on
   */
  /**
   * Disabled styles for default input elements
   */
  /**
   * Focus visible for input fields
   */
  /**
   * Placeholder styles for input fields
   */
  /**
   * Error textarea field
   */
  /**
   * Successful textarea field
   */
  /**
  * Hover styles for inputfield
  */
  /**
   * Focus styles for Inputfield 
  */
  /**
   * Changed border color for readonly state
   */
  /**
   * Padding for maxlength where there is no label
   */
  /**
   * Padding for small size
   */
  /**
   * If the input-field is medium, then adding padding
   */
  /**
   * Styles for the placeholder in input-field
   */
  /**
   * If the inputfield is readonly
   */
  /**
    adding style for Placeholder text
  */
  /**
    adding color for error state border 
  */
  /**
    Padding for input when the inputfield contains icons and it is in error or warning state.
  */
  /**
    Padding for input when the inputfield contains char and it is in error or warning state.
  */
  /**
  * Right padding in input field if icon or error-icon or warning-icon is present
  */
  /**
  * Right padding in input field for small size if error-icon or warning-icon is present
  */
  /**
  * Right padding in input field for medium size if error-icon or warning-icon is present
  */
  /**
  * Right padding in input field if character-after insert is present
  */
  /**
  * Right padding in input field if character insert icon is present
  */
  /**
  * Right padding in input field if character insert icon with error or warning state is present
  */
  /**
  * Left padding in input field if character-before insert is present
  */
  /*
  * Specific styling for type='tel'
  */
}
.cat-c-input-field__input:hover:not(:focus, :disabled) {
  color: var(--cat-theme-color-content-default-hover);
  border-color: var(--cat-theme-color-form-border-hover);
  background-color: var(--cat-theme-color-form-background-hover);
  /**
   * Hover styles for input with error state
   */
}
.cat-is-error .cat-c-input-field__input:hover:not(:focus, :disabled) {
  border-color: var(--cat-theme-color-border-utility-error-hover);
  background-color: var(--cat-theme-color-background-default);
}
.cat-is-error .cat-c-input-field__input:hover:not(:focus, :disabled) ~ .cat-icon, .cat-is-error .cat-c-input-field__input:hover:not(:focus, :disabled)::placeholder {
  color: var(--cat-theme-color-content-default);
}
.cat-c-input-field__input:focus:not(:disabled) {
  color: var(--cat-theme-color-content-default-hover);
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: -2px;
  border-color: var(--cat-theme-color-form-border-focus);
  /**
   * Focus styles for label & placeholder
   */
  /**
   * Focus styles for input with error state
   */
}
.cat-c-input-field__input:focus:not(:disabled) ~ .cat-c-input-field__label,
.cat-c-input-field__input:focus:not(:disabled) ~ .cat-icon {
  color: var(--cat-theme-color-content-default-hover);
}
.cat-c-input-field__input:focus:not(:disabled)::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-is-error .cat-c-input-field__input:focus:not(:disabled) ~ .cat-icon, .cat-is-error .cat-c-input-field__input:focus:not(:disabled)::placeholder {
  color: var(--cat-theme-color-content-default);
}
.cat-c-input-field__input:active:not(:disabled) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-input-field__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  /**
   * Disabled text colors
   */
  /**
   * Disabled text colors
   */
}
.cat-c-input-field__input:disabled ~ .cat-c-input-field__label, .cat-c-input-field__input:disabled:hover ~ .cat-c-input-field__label, .cat-c-input-field__input:disabled::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-error .cat-c-input-field__input:disabled ~ .cat-c-input-field__label, .cat-is-error .cat-c-input-field__input:disabled:hover ~ .cat-c-input-field__label, .cat-is-error .cat-c-input-field__input:disabled::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-input-field__input:disabled ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label, .cat-c-input-field__input:disabled:hover ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-error .cat-c-input-field__input:disabled ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label, .cat-is-error .cat-c-input-field__input:disabled:hover ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-input-field__input:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-input-field__input::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-is-error .cat-c-input-field__input {
  border-color: var(--cat-theme-color-border-utility-error);
}
.cat-is-error .cat-c-input-field__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
}
.cat-is-success .cat-c-input-field__input {
  border-color: var(--cat-theme-color-border-utility-success);
  background-color: var(--cat-theme-color-background-utility-success);
}
.cat-is-success .cat-c-input-field__input:hover, .cat-is-success .cat-c-input-field__input:focus {
  background-color: var(--cat-theme-color-background-utility-success);
}
.cat-is-success .cat-c-input-field__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
}
.cat-c-input-field__input {
  width: 100%;
  padding: var(--cat-input-padding-vert) var(--cat-input-padding-horiz);
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 2));
  z-index: 2;
}
.cat-c-input-field__input:hover:not(:focus, :disabled) {
  /**
   * color of placeholder on hover
  */
  /**
   * border color of input in error state on hover
  */
}
.cat-c-input-field__input:hover:not(:focus, :disabled)::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-is-error .cat-c-input-field__input:hover:not(:focus, :disabled) {
  border-color: var(--cat-theme-color-border-utility-error);
  background-color: var(--cat-theme-color-background-default-hover);
  /**
   * color of label in error state on hover
  */
  /**
   * color of placeholder in error state on hover
  */
}
.cat-is-error .cat-c-input-field__input:hover:not(:focus, :disabled) ~ .cat-c-input-field__label {
  color: var(--cat-theme-color-content-default);
}
.cat-is-error .cat-c-input-field__input:hover:not(:focus, :disabled)::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-c-input-field__input:focus:not(:disabled) {
  /**
   * Placeholder style for Inputfield in readonly state 
  */
  /**
  * Styles for Input in error state when focussed
  */
}
.cat-c-input-field:not(.cat-is-readonly) .cat-c-input-field__input:focus:not(:disabled)::placeholder {
  color: var(--cat-input-placeholder-color);
}
.cat-is-error .cat-c-input-field__input:focus:not(:disabled) {
  /**
  * color of placeholder and label in error state when focussed
  */
}
.cat-is-error .cat-c-input-field__input:focus:not(:disabled)::placeholder {
  color: var(--cat-input-placeholder-color);
}
.cat-is-error .cat-c-input-field__input:focus:not(:disabled) ~ .cat-c-input-field__label {
  color: var(--cat-theme-color-content-default);
}
.cat-is-readonly .cat-c-input-field__input {
  border-color: var(--cat-input-field-readonly--border-color, var(--cat-theme-color-border-readonly));
}
.cat-c-input-field--hidden-label.cat-c-input-field--maxlength .cat-c-input-field__input {
  padding-block: calc(var(--size-base-unit) * 3.25) calc(var(--size-base-unit) * 0.75);
}
.cat-c-input-field--small .cat-c-input-field__input {
  padding-block: calc(var(--size-base-unit) * 0.5);
  padding-inline: calc(var(--size-base-unit) * 1) var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 1));
  height: calc(var(--size-base-unit) * 4);
}
.cat-c-input-field--medium .cat-c-input-field__input {
  padding: calc(var(--size-base-unit) * 0.875) calc(var(--size-base-unit) * 1.5);
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 1.5));
}
.cat-c-input-field__input::placeholder {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  color: var(--cat-theme-color-content-subtle);
}
.cat-is-active:not(.cat-c-input-field--disabled) .cat-c-input-field__input {
  background-color: var(--cat-theme-color-background-default);
}
.cat-is-readonly .cat-c-input-field__input {
  pointer-events: var(--cat-input-pointer-events, none);
}
.cat-is-readonly .cat-c-input-field__input::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-c-input-field.cat-c-input-field--disabled .cat-c-input-field__input::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-error .cat-c-input-field__input:not(:active, :disabled, :focus) {
  outline: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
  outline-offset: calc(var(--size-base-unit) * -0.25);
}
.cat-has-icon--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 8));
}
.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 9));
}
.cat-has-icon--after .cat-c-input-field__input, .cat-is-error .cat-c-input-field__input, .cat-is-warning .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 5));
}
.cat-c-input-field--small:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 4));
}
.cat-c-input-field--medium:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 4.5));
}
.cat-has-char--after .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 6));
}
.cat-has-icon--after.cat-has-char--after .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 9));
}
.cat-has-icon--after.cat-has-char--after:is(.cat-is-warning, .cat-is-error) .cat-c-input-field__input {
  padding-inline-end: var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 12));
}
.cat-has-char--before .cat-c-input-field__input {
  padding-inline-start: calc(var(--size-base-unit) * 3.75);
}
.cat-c-input-field__input[type=tel] {
  /*
  * Start and end padding if icon-after is present or error or warning state is present
  */
  /*
  * Start and end padding if icon-after is present with error or warning state
  */
  /*
  * Start and end padding if size is medium with error or warning state is present
  */
  /*
  * Start and end padding if size is small with error or warning state is present
  */
  /*
  * Start and end padding if char-after is present
  */
  /*
  * Start and end padding if char-after is present with error or warning state (or) icon-after and char-after is present
  */
  /*
  * Start and end padding if icon-after and char-after is present with error or warning state
  */
  /*
  * Start and end padding if char-before is present with error or warning state
  */
  /*
  * Start and end padding if char-before is present
  */
}
.cat-has-icon--after .cat-c-input-field__input[type=tel], .cat-is-error .cat-c-input-field__input[type=tel], .cat-is-warning .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldPaddingStart, calc(var(--size-base-unit) * 2)) var(--rtlTelTypeInputFieldPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 5)));
}
.cat-has-icon--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldIconAfterErrPaddingStart, calc(var(--size-base-unit) * 2)) var(--rtlTelTypeInputFieldPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 8)));
}
.cat-c-input-field--medium:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldMedPaddingStart, calc(var(--size-base-unit) * 1.5)) var(--rtlTelTypeInputFieldMedPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 4.5)));
}
.cat-c-input-field--small:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldSmPaddingStart, calc(var(--size-base-unit) * 1)) var(--rtlTelTypeInputFieldSmPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 4)));
}
.cat-has-char--after .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldCharAfterPaddingStart, calc(var(--size-base-unit) * 2)) var(--rtlTelTypeInputFieldPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 6)));
}
.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input[type=tel], .cat-has-icon--after.cat-has-char--after .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldCharAfterErrPaddingStart, calc(var(--size-base-unit) * 2)) var(--rtlTelTypeInputFieldPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 9)));
}
.cat-has-icon--after.cat-has-char--after:is(.cat-is-warning, .cat-is-error) .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldIconCharAfterErrPaddingStart, calc(var(--size-base-unit) * 2)) var(--rtlTelTypeInputFieldPaddingEnd, var(--cat-input-padding-horiz-end, calc(var(--size-base-unit) * 12)));
}
.cat-has-char--before:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldPaddingStart, calc(var(--size-base-unit) * 3.75)) var(--rtlTelTypeInputFieldCharBeforePaddingEnd, calc(var(--size-base-unit) * 5));
}
.cat-has-char--before .cat-c-input-field__input[type=tel] {
  padding-inline: var(--rtlTelTypeInputFieldPaddingEnd, calc(var(--size-base-unit) * 3.75)) var(--rtlTelTypeInputFieldCharBeforePaddingEnd, calc(var(--size-base-unit) * 2));
}

/**
 * remove stepper when input field of type number is used.
 */
.cat-c-input-field.cat-is-hideStepper .cat-c-input-field__input::-webkit-outer-spin-button, .cat-c-input-field.cat-is-hideStepper .cat-c-input-field__input::-webkit-inner-spin-button {
  display: none;
}

/**
   * Styling for error and Warning icon in input
   */
.cat-c-input-field__warning-icon,
.cat-c-input-field__error-icon {
  position: absolute;
  pointer-events: none;
  z-index: var(--cat-z-index-100);
}
.cat-c-input-field--large:not(.cat-has-icon--after, .cat-has-char--after) .cat-c-input-field__warning-icon,
.cat-c-input-field--large:not(.cat-has-icon--after, .cat-has-char--after) .cat-c-input-field__error-icon {
  inset-inline-end: calc(var(--size-base-unit) * 2);
}
.cat-c-input-field--large .cat-c-input-field__warning-icon,
.cat-c-input-field--large .cat-c-input-field__error-icon {
  inset-block-end: calc(var(--size-base-unit) * 1.375);
}
.cat-c-input-field--small .cat-c-input-field__warning-icon,
.cat-c-input-field--small .cat-c-input-field__error-icon {
  inset-inline-end: calc(var(--size-base-unit) * 1);
  inset-block-end: calc(var(--size-base-unit) * 1.125);
}
.cat-c-input-field--medium .cat-c-input-field__warning-icon,
.cat-c-input-field--medium .cat-c-input-field__error-icon {
  inset-inline-end: calc(var(--size-base-unit) * 1.5);
  inset-block-end: calc(var(--size-base-unit) * 1.625);
}
.cat-has-icon--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__warning-icon,
.cat-has-icon--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__error-icon {
  inset-inline-end: calc(var(--size-base-unit) * 5);
}
.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__warning-icon,
.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__error-icon {
  inset-inline-end: calc(var(--size-base-unit) * 2);
}
.cat-has-icon--after.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__warning-icon,
.cat-has-icon--after.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__error-icon {
  inset-inline-end: calc(var(--size-base-unit) * 5);
}

/**
 * Padding for input fields with labels and hiddenlabel with required state
 */
.cat-c-input-field:not(.cat-c-input-field--hidden-label).cat-c-input-field--large .cat-c-input-field__input,
.cat-c-input-field--hidden-label.cat-c-input-field--required .cat-c-input-field__input {
  padding-block: calc(var(--size-base-unit) * 3.25) calc(var(--size-base-unit) * 0.75);
  height: calc(var(--size-base-unit) * 7);
}

/**
 * Padding for input fields for Hidden Label
 */
.cat-c-input-field--hidden-label:not(.cat-c-input-field--maxlength, .cat-c-input-field--required).cat-c-input-field--large .cat-c-input-field__input {
  padding-block: calc(var(--size-base-unit) * 0.75);
}

/**
 * Hide the placeholder by default because the label
 * acts as the native placeholder, unless the label is hidden
 */
.cat-c-input-field:not(.cat-c-input-field--hidden-label, .cat-has-placeholder) .cat-c-input-field__input::placeholder {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Input (and other optional elements) wrapper
 */
.cat-c-input-field__body {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

/**
* input field footer
*/
.cat-c-input-field__footer {
  display: flex;
  justify-content: flex-end;
  word-break: break-word;
}
.cat-c-input-field__footer slot[name=field-note] {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}

/**
* input field  field note in the footer
*/
.cat-c-input-field__field-note {
  flex-basis: 100%;
}
.cat-is-error .cat-c-input-field__field-note {
  color: var(--cat-theme-color-content-utility-error);
}
.cat-c-input-field--small .cat-c-input-field__field-note {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Color for required-text for required fields
 */
.cat-c-input-field__required-text {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  color: var(--cat-theme-color-content-subtle);
  margin-inline: calc(var(--size-base-unit) * 0.5);
}
.cat-c-input-field--large .cat-c-input-field__required-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: var(--cat-c-input-field-notation-overflow, visible);
  max-width: 50%;
}
.cat-c-input-field--disabled .cat-c-input-field__required-text {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-input-field--hidden-label .cat-c-input-field__required-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Styles for required-text for required fields when label is hidden
 */
.cat-c-input-field--required .cat-c-input-field__required-text--no-label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Styles for disabled field note ,  prefix and suffix disabled
 */
.cat-c-input-field--disabled {
  cursor: not-allowed;
  /**
  * Styles for disabled error and warning icons
  */
}
.cat-c-input-field--disabled .cat-icon,
.cat-c-input-field--disabled .cat-c-input-field__char-insert {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-input-field--disabled .cat-c-input-field__error-icon,
.cat-c-input-field--disabled .cat-c-input-field__warning-icon {
  display: none;
}
.cat-c-input-field--disabled .cat-c-input-field__required-text,
.cat-c-input-field--disabled .cat-c-input-field__required-text--no-label {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-input-field--disabled .cat-c-input-field__wrap {
  pointer-events: none;
}

/**
 * Size and position default icons
 */
::slotted(cat-icon),
::slotted(.cat-icon),
.cat-c-input-field__char-insert {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  position: absolute;
  transition: all 0.15s ease;
  transform: var(--cat-icon-transform);
  z-index: var(--cat-z-index-100);
}

/**
 * Styles for icons after input
 */
::slotted(.cat-icon[slot=after]) {
  transform: var(--cat-icon-after-transform);
}

/**
 * Inserted character position after icon
 */
.cat-c-input-field__char-insert {
  display: block;
  /**
   * Styling for char after when error or Warning icon is there
   */
}
:not(.cat-c-input-field--disabled).cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__char-insert {
  inset-inline-end: calc(var(--size-base-unit) * 5);
}
:not(.cat-c-input-field--disabled).cat-has-icon--after.cat-has-char--after:is(.cat-is-error, .cat-is-warning) .cat-c-input-field__char-insert {
  inset-inline-end: calc(var(--size-base-unit) * 8);
}

:not(.cat-c-input-field__required-text--no-label).cat-c-input-field__char-insert {
  font-weight: var(--cat-font-weight-regular);
  font-size: var(--cat-font-size-16);
  line-height: 16px;
}
.cat-c-input-field:not(.cat-c-input-field--disabled) :not(.cat-c-input-field__required-text--no-label).cat-c-input-field__char-insert {
  color: var(--cat-theme-color-content-subtle);
}

/**
 * Adjust position of Icon after
 */
.cat-c-input-field--large .cat-c-input-field__input ~ ::slotted(.cat-icon:first-of-type),
.cat-c-input-field--large .cat-c-input-field__char-insert {
  inset-block-end: calc(var(--size-base-unit) * 1.375);
}
.cat-c-input-field--small .cat-c-input-field__input ~ ::slotted(.cat-icon:first-of-type),
.cat-c-input-field--small .cat-c-input-field__char-insert {
  inset-block-end: calc(var(--size-base-unit) * 1.125);
}
.cat-c-input-field--medium .cat-c-input-field__input ~ ::slotted(.cat-icon:first-of-type),
.cat-c-input-field--medium .cat-c-input-field__char-insert {
  inset-block-end: calc(var(--size-base-unit) * 1.625);
}

/**
 * character insert before horizontal position
 */
.cat-has-char--before .cat-c-input-field__char-insert--before {
  inset-inline-start: calc(var(--size-base-unit) * 2);
}

/**
 * Icon insert after horizontal position
 */
.cat-has-icon--after [name=after]::slotted(cat-icon),
.cat-has-icon--after [name=after]::slotted(.cat-icon) {
  inset-inline: auto calc(var(--size-base-unit) * 2);
}

.cat-c-input-field__char-insert--after {
  /**
  * character insert after horizontal position
  */
}
.cat-has-icon--after.cat-has-char--after .cat-c-input-field__char-insert--after {
  inset-inline: auto calc(var(--size-base-unit) * 5);
}
.cat-has-char--after .cat-c-input-field__char-insert--after {
  inset-inline: auto calc(var(--size-base-unit) * 2);
}

/**
 * Input field wrap
 */
.cat-c-input-field__wrap {
  height: 100%;
}

/**
 * Input field notes
 * The container for the field notes and to span the width of the input
 */
.cat-c-input-field__field-notes {
  flex: 1;
}

/**
 * Edge browser adds a password reveal icon default when input type is password.
 * https://learn.microsoft.com/en-us/microsoft-edge/web-platform/password-reveal
 */
.cat-c-input-field__input::-ms-reveal {
  display: none;
}

/**
 * Apply gap between loaders 
 */
.cat-c-input-field--loader {
  display: flex;
  flex-direction: column;
  gap: calc(var(--size-base-unit) * 0.5);
}

/**
 * Inputfield area height in loader state.
 */
.cat-c-input-field__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3.5);
  position: relative;
}
.cat-c-input-field--medium .cat-c-input-field__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
}
.cat-c-input-field--small .cat-c-input-field__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}

/**
 *  Fieldnote loader height for small size in loader state.
 */
.cat-c-input-field--small .cat-c-input-field__fieldnote-loader {
  display: none;
}

.cat-is-readonly {
  pointer-events: none;
}
`;
       